/**
 * 處理 URL 查詢參數並儲存到 cookie 和 store
 * @param {Object} context - Nuxt 插件上下文
 * @param {Object} context.$auth - 認證模組
 * @param {Object} context.store - Vuex store
 * @param {Object} context.query - URL 查詢參數
 */
export default ({ $auth, store, query }) => {
  const routerSave = $auth.$storage.getCookie('routerSave') || {}

  if (!query) return

  const setCookieParams = ['referrer', 'channel', 'discount']
  const existingQuery = setCookieParams.filter(param => query[param])
  if (existingQuery.length) {
    existingQuery.forEach(param => {
      routerSave[param] = query[param]
    })
    $auth.$storage.setCookie('routerSave', routerSave, { expires: 1 })
  }

  const hasUtmParams = query.utm_source && query.utm_medium
  if (hasUtmParams) {
    const isFacebookAds = query.utm_source === 'Facebook' && query.utm_medium === 'AD'
    store.commit('setIsFromFacebookAds', isFacebookAds)
  }
}
